export default __webpack_public_path__ + "static/media/ESSC16XIAB01_1920x1080.5d43fac5.jpg";